"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = void 0;
var Home_1 = require("./Home");
Object.defineProperty(exports, "Home", { enumerable: true, get: function () { return Home_1.Home; } });
